<template>
  <el-dialog
    title=""
    :visible.sync="dialog"
    width="300px"
    class="course-poster"
    @opened="onOpen"
  >
    <div class="poster-box">
      <div ref="poster" class="poster-container">
        <div class="course-cover">
          <img
            v-if="courseInfo.cover_url"
            :src="courseInfo.cover_url + '?imageView2/0/w/300'"
            alt=""
            @load="onLoad"
          />
        </div>
        <div class="course-name multiline-ellipsis">
          {{ courseInfo.course_name }}
        </div>
        <div class="price">
          <span v-if="courseInfo.goods && courseInfo.goods.price" class="symbol"
            >¥</span
          >{{ price }}
        </div>
        <div class="teacher-info">
          <img :src="userInfo.avatar" alt="" />
          <div class="info">
            <div class="teacher-name">
              {{ userInfo.nickname }}
            </div>
            <div v-show="roomInfo.isTeacher" class="teacher-desc ellipsis">
              {{ userInfo.profile }}
            </div>
          </div>
        </div>
        <div class="qr-area">
          <div class="logo">
            <img src="@saas/pages/assets/images/live/favicon.png" alt="" />
          </div>
          <div class="center">
            <div class="top">
              <div>长按识别二维码</div>
              <img src="@saas/pages/assets/images/live/hand-arrow.png" alt="" />
            </div>
            <div class="bottom">来魔果上好课！</div>
          </div>
          <div class="qr-img">
            <img :src="qrCodeUrl" alt="" @load="onLoadQr" />
          </div>
        </div>
      </div>
      <div class="btn-area">
        <div class="btn-item" @click="handleShare('weibo')">
          <img src="@saas/pages/assets/images/live/weibo.png" alt="" />
          <div class="text">微博</div>
        </div>

        <div class="btn-item" @click="downloadPoster">
          <img src="@saas/pages/assets/images/live/download.png" alt="" />
          <div class="text">保存图片</div>
        </div>
      </div>
      <div class="loading" v-if="loading">加载中...</div>
    </div>

    <div class="close-img">
      <img
        src="@saas/pages/assets/images/live/close.png"
        alt=""
        @click="dialog = false"
      />
    </div>
  </el-dialog>
</template>

<script>
import html2canvas from "html2canvas";
import { cosUploadFile } from "@saas/components/src/utils/cos-upload";
import { getUploadSignature } from "@saas/service-api/src/material/index.js";
import shareSdk from "@saas/components/src/utils/share";
import { getCdnUrl } from "@saas/components/src";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
export default {
  props: {
    // courseInfo: {
    //   type: Object,
    //   default: () => {},
    // },
    qrCodeUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dialog: false,
      loading: false,
      logoUrl: process.env.VUE_APP_CDN_URL + "/cdn/static/images/favicon.ico",
      // 海报地址
      posterUrl: "",
      // base64图片
      posterBase64: "",
      isloadOver: false,
    };
  },
  computed: {
    ...mapState("live", [
      "cameraList",
      "liveService",
      "microphoneList",
      "speakerList",
      "layout",
      "roomInfo",
      "courseInfo",
    ]),
    courseDetailUrl() {
      return `${process.env.VUE_APP_SAAS_WEB_URL}/product-detail/${this.roomInfo.course_id}`;
    },
    posterName() {
      return "课程海报-" + this.courseInfo.course_name + ".png";
    },
    price() {
      if (this.courseInfo.goods && this.courseInfo.goods.price) {
        return (this.courseInfo.goods.price / 100).toFixed(2);
      } else {
        return "免费";
      }
    },
    userInfo() {
      return this.$store.getters.user || {};
    },
    showDesc() {
      return this.userInfo.profile;
    },
  },
  watch: {
    qrCodeUrl: {
      handler(val) {
        if (val) {
          // this.isloadOver = false
        }
      },
      immediate: true,
    },
  },
  methods: {
    onOpen() {
      // this.$nextTick(() => {
      //   this.createPoster()
      // })
    },
    onLoad() {
      console.log("load加载完成");
      this.isloadOver = true;
      this.loading = true;
      this.$nextTick(() => {
        this.createPoster();
      });
    },
    onLoadQr() {
      // this.isloadOver = true
      // this.$nextTick(() => {
      //   this.createPoster()
      // })
    },
    open() {
      this.dialog = true;
      if (this.posterUrl) {
        this.loading = false;
      } else {
        this.loading = true;
      }
    },
    handleShare(type) {
      if (type === "weibo") {
        if (!this.posterUrl) {
          this.$darkMessage.error("海报正在上传中，请稍后重试");
          return;
        }
        shareSdk("weibo", {
          url: this.courseDetailUrl, // 分享地址
          title: this.courseInfo.course_name, // 分享标题
          pic: this.posterUrl,
        });
      }
    },
    // 创建海报
    createPoster() {
      if (!this.isloadOver) {
        return;
      }
      const dom = document.querySelector(".poster-container");
      // 解决文字偏移问题
      // const style = document.createElement('style')
      // document.head.appendChild(style)
      // style.sheet?.insertRule('body > div:last-child img { display: inline-block; }')
      html2canvas(dom, {
        backgroundColor: null,
        width: dom.clientWidth,
        height: dom.clientHeight,
        scrollX: 0,
        scrollY: 0,
        scale: 4,
        useCORS: true,
        onclone: (clone) => {
          const dom = clone.querySelector(".poster-container");
          dom.style.borderRadius = "20px";
          dom.style.overflow = "hidden";
          dom.style.backgroundColor = "transparent";
          // clone.querySelector('body > div:last-child img').style.display = 'inline-block'
        },
      })
        .then((canvas) => {
          const dataUrl = canvas.toDataURL("image/png");
          this.posterBase64 = dataUrl;
          const file = this.convertBase64ToFile(
            dataUrl,
            this.posterName + ".png"
          );
          console.log("file", file);
          const fileData = {
            raw: file,
            name: this.posterName + ".png",
            url: "",
            percentage: 0,
            status: 0,
            cancelSource: null,
            taskId: "",
          };
          this.uploadPoster(fileData);
        })
        .catch(() => {
          this.loading = false;
        });
    },
    downloadPoster() {
      if (this.posterBase64) {
        const img = new Image();
        img.src = this.posterBase64;
        img.onload = () => {
          // 下载
          const a = document.createElement("a");
          a.href = this.posterBase64;
          a.download = this.posterName;
          a.click();
          // 销毁元素
          a.remove();
        };
      } else {
        this.$darkMessage.error("海报正在生成中，请稍后重试");
      }
    },
    // 上传海报
    uploadPoster(fileData) {
      getUploadSignature({
        fileName: fileData.name,
        materialType: 99,
      }).then((res) => {
        if (res.code === 1) {
          fileData.cos = cosUploadFile(
            {
              file: fileData.raw,
              fileName: fileData.name,
              type: 99, //
            },
            {
              ...res.data,
            },
            {
              onFileFinish: (err, data, options) => {
                this.loading = false;
                if (data && data.statusCode === 200) {
                  console.log("onFileFinish-data", data);
                  const location = data.Location;
                  const arr = location.split("/");
                  arr.shift();
                  this.posterUrl = getCdnUrl("/" + arr.join("/"));
                  // this.posterUrl = data.Location.startsWith("https://")
                  //   ? data.Location
                  //   : "https://" + data.Location;
                  this.$emit("getPosterUrl", this.posterUrl);
                } else {
                  console.log(err);
                }
              },
            }
          );
        }
      });
    },
    convertBase64ToFile(data, name) {
      if (data) {
        const base64String = data.split(",")[1]; // 去掉数据 URI 的前缀
        const byteCharacters = atob(base64String);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "image/png" }); // 根据实际情况调整 MIME 类型
        return new File([blob], name, { type: "image/png" });
      } else {
        return null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.course-poster ::v-deep {
  .el-dialog {
    border-radius: 20px !important;
    background-color: unset;
    // overflow: hidden;
  }
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
  }
}
.poster-box {
  position: relative;
  .loading {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    backdrop-filter: blur(7px); /* 设置高斯模糊效果 */
    background-color: rgba(0, 0, 0, 0.2); /* 背景颜色 */
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
  }
}
.poster-container {
  width: 300px;
  height: 396px;
  background: url("~@saas/pages/assets/images/live/bg.png");
  background-size: 100% auto;
  background-repeat: no-repeat;
  padding: 20px 20px 26px 20px;
  background-color: transparent;
  .course-cover {
    width: 260px;
    height: 146px;
    border-radius: 16px;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .course-name {
    height: 40px;
    margin-top: 10px;
    font-weight: 500;
    font-size: 15px;
    color: #0d1400;
    line-height: 20px;
  }
  .price {
    margin-top: 7px;
    font-weight: 800;
    font-size: 16px;
    color: #f03349;
    line-height: 20px;
    .symbol {
      font-weight: 800;
      font-size: 11px;
      color: #f03349;
      line-height: 12px;
    }
  }
  .teacher-info {
    width: 100%;
    height: 54px;
    padding: 10px;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.6);
    margin-top: 6px;
    img {
      width: 34px;
      height: 34px;
      margin-right: 8px;
      border-radius: 6px;
    }
    .info {
      .teacher-name {
        font-weight: 600;
        font-size: 12px;
        color: #000000;
        line-height: 17px;
      }
      .teacher-desc {
        margin-top: 2px;
        font-weight: 400;
        font-size: 11px;
        color: #515350;
        line-height: 16px;
      }
    }
  }
  .qr-area {
    margin-top: 27px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .logo {
      width: 38px;
      height: 38px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .center {
      flex: 1;
      margin-left: 6px;
      .top {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        div {
          font-weight: 400;
          font-size: 10px;
          color: #515350;
          line-height: 18px;
          margin-right: 5px;
        }
        img {
          width: 17px;
          height: 18px;
        }
      }
      .bottom {
        margin-top: 1px;
        font-weight: 500;
        font-size: 13px;
        color: #0d1400;
        line-height: 18px;
      }
    }
    .qr-img {
      width: 42px;
      height: 42px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
.btn-area {
  width: 100%;
  height: 105px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 70px;
  align-items: center;
  background: #fff;
  margin-top: -1px;
  border-radius: 0 0 20px 20px;
  .btn-item {
    cursor: pointer;
    width: 50px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      width: 50px;
      height: 50px;
    }
    .text {
      margin-top: 6px;
      font-weight: 400;
      font-size: 12px;
      color: #0d1400;
      line-height: 17px;
    }
  }
}
.close-img {
  width: 26px;
  height: 26px;
  cursor: pointer;
  position: absolute;
  left: 50%;
  bottom: -46px;
  transform: translateX(-50%);
  img {
    width: 100%;
    height: 100%;
  }
}

// 两行 溢出隐藏
.multiline-ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  /* 调整这里的数值以适应需要显示的行数 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
